import React from 'react';
import PropTypes from 'prop-types';
import { ThreeDots } from  'react-loader-spinner';

const Loader = (props) => {
    const {
        show = true,
        fullPage = false,
        message
    } = props;
    let wrapperClassName = 'flex flex-col justify-center items-center ';
    let color = "#be123c";

    if(fullPage) {
        wrapperClassName += ' fixed w-100 inset-0 bg-black/50 z-10';
        color = "white";
    }

    return (
        <>
        {
            show ? (
                <div className={wrapperClassName}>
                <ThreeDots 
                    height="80" 
                    width="80" 
                    radius="5"
                    color={ color }
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=''
                    visible={true}
                />
                {
                    message ? <h1 className={`text-${color}`}>{message}</h1> : null
                }
            </div>
            ) : null
        }
        </>
    )
}

Loader.propTypes = {
    show : PropTypes.bool,
    fullPage : PropTypes.bool,
    message : PropTypes.string
};

export default Loader;